[
  {
    "code": "SO-AW",
    "name": "Awdal"
  },
  {
    "code": "SO-BK",
    "name": "Bakool"
  },
  {
    "code": "SO-BN",
    "name": "Banaadir"
  },
  {
    "code": "SO-BR",
    "name": "Bari"
  },
  {
    "code": "SO-BY",
    "name": "Bay"
  },
  {
    "code": "SO-GA",
    "name": "Galguduud"
  },
  {
    "code": "SO-GE",
    "name": "Gedo"
  },
  {
    "code": "SO-HI",
    "name": "Hiiraan"
  },
  {
    "code": "SO-JD",
    "name": "Jubbada Dhexe"
  },
  {
    "code": "SO-JH",
    "name": "Jubbada Hoose"
  },
  {
    "code": "SO-MU",
    "name": "Mudug"
  },
  {
    "code": "SO-NU",
    "name": "Nugaal"
  },
  {
    "code": "SO-SA",
    "name": "Sanaag"
  },
  {
    "code": "SO-SD",
    "name": "Shabeellaha Dhexe"
  },
  {
    "code": "SO-SH",
    "name": "Shabeellaha Hoose"
  },
  {
    "code": "SO-SO",
    "name": "Sool"
  },
  {
    "code": "SO-TO",
    "name": "Togdheer"
  },
  {
    "code": "SO-WO",
    "name": "Woqooyi Galbeed"
  }
]